import React from 'react'

import Image from '../layouts/Image.jsx'

import sharethisOverviewImage from '_static/img/audience-insights/sharethis-overview.png'

const SharethisOverview = ({ index }) => (
  <Image
    imageUrl={sharethisOverviewImage}
    page={index + 1}
    footerTheme={{ background: 'dark', icon: 'light', page: 'light' }}
  />
)

export default SharethisOverview
